import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import researchVennDiagram from '@/assets/research-venn-diagram.webp';

export function ResearchAreasSection() {
  const researchAreas = [
    { 
      name: 'NorthPop', 
      path: '/northpop', 
      position: 'left-[18%] top-[50%] -translate-x-1/2 -translate-y-1/2'
    },
    { 
      name: 'Neurodevelopment', 
      path: '/neurodevelopment', 
      position: 'left-[50%] top-[28%] -translate-x-1/2 -translate-y-1/2'
    },
    { 
      name: 'Neonatology', 
      path: '/neonatology', 
      position: 'left-[82%] top-[50%] -translate-x-1/2 -translate-y-1/2'
    },
    { 
      name: 'Nutrition', 
      path: '/nutrition', 
      position: 'left-[50%] top-[72%] -translate-x-1/2 -translate-y-1/2'
    },
  ];

  return (
    <section id="research-areas" className="py-16 md:py-24">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-heading text-3xl font-bold tracking-tight md:text-4xl">
            The N4 Research Group
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            The N4 Research Group is a multidisciplinary team focusing on clinical intervention studies, cohort studies, mechanistic research, innovation and implementation in the following areas of pediatrics:
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12 flex justify-center"
        >
          <div className="relative inline-block w-full max-w-[500px] md:max-w-[700px]">
            <img 
              src={researchVennDiagram} 
              alt="Research Areas Venn Diagram showing interconnected research programs"
              className="w-full h-auto"
              width={700}
              height={700}
              loading="eager"
            />
            
            {researchAreas.map((area) => (
              <Link 
                key={area.name}
                to={area.path}
                className={`absolute ${area.position} font-heading font-semibold text-sm md:text-base lg:text-lg text-steel-blue hover:text-primary transition-colors underline decoration-steel-blue/40 hover:decoration-steel-blue underline-offset-4`}
              >
                {area.name}
              </Link>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
